import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_ServiceUsagesGroup_Update_Mutation =
  graphql(`
    mutation ResolvableMissionTypeForm_ServiceUsagesGroup_Update(
      $isOptional: Boolean
      $label: String!
      $serviceUsagesGroupId: Id!
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      updateResolvableMissionTypeServiceUsagesGroup(
        isOptional: $isOptional
        label: $label
        serviceUsagesGroupId: $serviceUsagesGroupId
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useUpdateResolvableMissionTypeServiceUsagesGroupMutation = () =>
  useGraphQLMutation(
    ResolvableMissionTypeForm_ServiceUsagesGroup_Update_Mutation,
  );
